<template>
  <section>
    <v-dialog
      v-model="isOpen"
      showClose
      fullscreen
      @closed="handleClose">
      <div class="dialog-container">
        <div class="dialog-header">
          <h3>{{title}}</h3>
        </div>
        <div class="dialog-body">

          <div class="form-card">
            <div class="form-left">
              <div
                class="upload-card"
                :class="{'upload-card__pdf':isPdf}">
                <embed
                  v-if="isPdf"
                  :src="photoUrl"
                  width="100%"
                  height="100%"
                  type="application/pdf">
                <el-image
                  v-else
                  :src="photoUrl"
                  :preview-src-list="[photoUrl]"
                >
                </el-image>
              </div>
            </div>
            <div
              v-if="isTicket&&type!=1||!isTicket"
              class="form-right">
              <ticket-detail
                v-if="isTicket"
                :type="type"
                :form="form"
                :customer="customer">
              </ticket-detail>
              <policy-detail
                v-else
                :form="form"
                :customer="customer"></policy-detail>
            </div>
          </div>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import PolicyDetail from '@/views/records/policy/components/info/policy-detail'
import TicketDetail from '@/views/tickets/components/info/ticket-detail'

export default {
  name: 'showDetailDialog',
  components: {
    PolicyDetail,
    TicketDetail
  },

  mixins: [MixinOptions],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type:{
      type: Number,
      default: 0
    },
    isTicket: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => ({})
    },
    customer: {
      type: Object,
      default: () => ({})
    },
    file: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      formData: {},
      isOpen: false,
    }
  },
  computed: {
    isPdf() {
      const { client_name,path } = this.formData
      if(client_name||path) {
        if(String(client_name).toLowerCase().indexOf('.pdf') != -1||String(path).toLowerCase().indexOf('.pdf') != -1) {
          return true
        }
      }
      return false
    },
    photoUrl() {
      if (this.formData.url)
        return this.formData.url || ''
      else return ''
    },
    title(){
      let { title=''} = this.file||{}
      return title
    }
  },
  watch: {
    file: {
      deep: true,
      immediate: true,
      handler(val) {
        let {fileData={}} = val||{}
        this.formData = JSON.parse(JSON.stringify(fileData))||{}
      }
    },
    value:{
      immediate: true,
      handler(val) {
        this.isOpen = val
      }
    }
  },
  methods: {
    handleClose(){
      this.$emit('input',false)
    },
    network() {
      return {
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/.el-dialog__body{
  overflow-y: hidden;
}
/deep/.el-dialog{
  &.is-fullscreen{
    overflow-y: hidden;
  }
}

.dialog-container {
  .dialog-header {
    padding: 15px 15px 0;
  }

  .table .tr {
    padding: 10px;
  }

  .form-card {
    display: flex;
    background: white;
    border-radius: 4px;
    // box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    height: calc( 100vh - 31px);

    .form-left,
    .form-right {
      flex: 1;
    }

    .form-left {
      //padding: 20px;
      display: flex;
      //justify-content: center;
      //align-items: center;
      background: rgb(88, 96, 105);
      flex-direction: column;
      overflow-y: auto;
      .title-h3 {
        background: #FAFBFC;
        color: #24292E;
        padding: 15px;
        font-size: 14px;
        justify-self: flex-start;
        align-self: flex-start;
        width: 100%;
        //position: absolute;
      }
    }

    .form-right {
      padding: 20px;
      border-left: 1px solid #dddfe7;
      overflow: auto;
      .box{
        height: calc(100% - 30px);
      }
    }

    .form-block {
      margin-bottom: 15px;

      & > span:first-child {
        display: block;
        padding-bottom: 5px;
        color: #616266;
        font-weight: bold;
        font-size: 14px;
      }
    }

    .title {
      display: block;
      padding-bottom: 15px;
      color: #616266;
      font-size: 20px;
      font-weight: 500;
    }

    .form-flex {
      display: flex;
      justify-content: space-between;

      & > .form-block {
        margin-right: 15px;

        &:last-child {
          margin-right: 0;
        }
      }
    }


  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 15px;
  }

  .upload-card {
    z-index: 0;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    margin: auto;
    width: 100%;
    //height: -webkit-fill-available;
    //overflow-y: auto;
    &__pdf{
      height: 100%;
    }
    img {
      max-width: 100%;
      max-height: 100%;
    }
    .el-image{
      max-height: 100%;
    }
  }
}
</style>
